<script setup>
defineProps({
  value: String,
  required: {
    type: Boolean,
    default: false
  },

});
</script>

<template>
  <label class="block text-sm leading-6 text-stone-900 mb-1">
    <span v-if="value">{{ value }}</span>
    <span v-else><slot /></span>
    <span v-if="required" class="text-red-700"> *</span>
  </label>
</template>
